import { mapActions } from "vuex";

export const clusterOptionsMixin = {
  computed: {
    showInstruction() {
      return this.currentInstruction !== "";
    },
    selectedToolObjectLayer() {
      return this.$store.getters.tools_selectedObjectLayer;
    }
  },
  methods: {
    ...mapActions([
      "GET_LIST",
      "fetchStockMaterialsList",
      "fetchWorkspaceByUUID",
      "UPDATE_SELECTED_OBJECT_IDENTIFIERS",
      "UPDATE_SELECTED_OBJECT_DATA",
      "fetchObjectByUUID"
    ]),

    getObjectDataFromClusterMenu(objectIdentifiers, formType) {
      let endpoint = objectIdentifiers.endpoint;
      let uuid = objectIdentifiers.uuid;
      let fields = this.getFields(endpoint);
      let layerName = objectIdentifiers.layerName;

      this.fetchObjectByUUID({
        endpoint: endpoint,
        objectUUID: uuid,
        fieldsToInclude: fields
      })
        .then(resp => {
          this.UPDATE_SELECTED_OBJECT_IDENTIFIERS(objectIdentifiers);
          this.UPDATE_SELECTED_OBJECT_DATA(resp.data.data[0]);
          if (formType === "detail") {
            this.$emit("openForm", "Detail", "edit");
          } else {
            this.$emit("openForm", layerName, formType);
          }
        })
        .catch(error => {
          this.$toasted.global.toast_error(error.response.data.data);
        });
    },

    getFields(endpoint) {
      switch (endpoint) {
        case "closures":
          return "technicalpoint,fiberterminalbox";
        case "buildings":
          return "images,technicalsite,technicallocals";
        default:
          return "";
      }
    },

    closeClusterObjectMenu() {
      this.clusterObjectMenu.open = false;
    },

    openFormFromClusterObjectMenu(action) {
      this.closeClusterObjectMenu();
      this.getObjectDataFromClusterMenu(this.clusterObjectMenu.object, action);
    },

    updateGeoServer() {
      this.$emit("updateGeoserver");
    },

    openClusterObjectMenu(ev, object) {
      this.clusterObjectMenu.open = true;
      this.clusterObjectMenu.event = ev;
      this.clusterObjectMenu.object = object;
    },

    async loadOwnerOptions({ callback }) {
      try {
        let codes = [this.fields.cable_owner, this.fields.pathway_owner];
        this.ownersOptions = await this.GET_LIST({
          listName: "list_organization",
          code: codes
        });
      } catch (error) {
        console.log(error);
      }
      callback();
    },

    async loadPathwayTypeOptions({ callback }) {
      try {
        this.pathwayTypeOptions = await this.GET_LIST({
          listName: "list_implantation_type",
          code: [this.fields.pathway_type]
        });
      } catch (error) {
        console.log(error);
      }
      callback();
    },

    normalizerList(node) {
      return {
        id: node.code,
        label: node.client_label ? node.client_label : node.libelle,
        isDisabled: node.deleted
      };
    },

    async getMaterialOptions(
      familyId,
      workspace_uuid = null,
      network_level_id = null
    ) {
      try {
        if (workspace_uuid && network_level_id) {
          return await this.fetchStockMaterialsList({
            material_family_id: familyId,
            workspace_uuid: workspace_uuid,
            network_level_id: network_level_id
          });
        } else {
          return await this.fetchStockMaterialsList({
            material_family_id: familyId
          });
        }
      } catch (e) {
        console.log(e);
      }
    },

    async loadMaterialCableOptions({ callback }) {
      this.materialCableOptions = await this.getMaterialOptions(
        "ca",
        this.$store.getters.workspace.uuid,
        1
      );
      callback();
    },

    async loadMaterialPathwayOptions({ callback }) {
      this.materialPathwayOptions = await this.getMaterialOptions("pt");
      callback();
    },

    normalizerMaterial(node) {
      let label = node.sm_short_description
        ? node.sm_short_description
        : node.sm_description;

      return { id: node.sm_id, label: label };
    },
    //gets workspace status
    async getWorkspacePhaseValue() {
      try {
        let workspace = await this.fetchWorkspaceByUUID({
          uuid: this.$store.getters.workspace.uuid,
          includes: "",
          fields: "wp_uuid,wp_status,wp_id"
        });
        return workspace.wp_status;
      } catch (error) {
        console.log(error);
      }
    },
    /**
     * Get maximum hps from closure material
     * @param closure
     */
    async getMaxHpsFromClosureMaterial(closure) {
      try {
        let queryParameters = {
          workspace_uuid: this.$store.getters.workspace.uuid,
          material_family_id: "cl"
        };
        if (closure.cl_logical_type) {
          queryParameters.closure_type = closure.cl_logical_type;
        }

        let result = await this.fetchStockMaterialsList(queryParameters);

        let material = result.find(
          material => material.sm_id === closure.cl_material_id
        );

        return material.smcl_max_hps;
      } catch (e) {
        console.error(e);
      }
    },
    //clusterWindow when changes values in form
    changeValue(event) {
      this[event.prop] = event.value;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/clusterOptionsMixin.js